{
    const links = document.getElementsByClassName('nav-content__left-link')
    const images = document.getElementsByClassName('nav-content__background')
    const navSecondary = document.getElementsByClassName('nav-secondary__title')
    const navSecMenu = document.getElementsByClassName('nav-secondary__nav')

    if (links.length > 1) {
        const imageNodes = Array.from(images)
        Array.from(links).forEach((link, key) => {
            link.addEventListener('mouseenter', () => {
                imageNodes.forEach((node) => {
                    node.classList.remove('active')
                })
                if (imageNodes[key])
                    imageNodes[key].classList.add('active')
            })
        })
    }

    if (navSecondary.length > 0) {
        Array.from(navSecondary).forEach((_, i) => {
            const arrow = document.getElementsByClassName('nav-secondary__arrow')[i]
            const menu = navSecMenu[i]
            if (!arrow || !menu)
                return

            if (menu.classList.contains('nav-secondary__nav-parent')) {
                if (window.innerWidth <= 640)
                    menu.setAttribute('aria-hidden', 'true')
            }
            else {
                menu.setAttribute('aria-hidden', 'true')
            }

            const toggleSecNav = () => {
                if (menu.classList.contains('active')) {
                    menu.classList.remove('active')
                    arrow.setAttribute('aria-expanded', 'false')
                    menu.setAttribute('aria-hidden', 'true')
                }
                else {
                    menu.classList.add('active')
                    arrow.setAttribute('aria-expanded', 'true')
                    menu.setAttribute('aria-hidden', 'false')
                }
            }

            arrow.addEventListener('click', toggleSecNav)
            arrow.addEventListener('keypress', (e) => {
                if (e.charCode === 13)
                    toggleSecNav()
            })
            arrow.addEventListener('touchend', (event) => {
                event.preventDefault()
                toggleSecNav()
            })
        })
    }

    const navTertiaryAll = document.getElementsByClassName('nav-tertiary__link')
    const navTertMenuAll = document.getElementsByClassName('nav-tertiary__nav')

    if (navTertiaryAll.length > 0) {
        const hideMenu = (menu) => {
            menu.style.padding = '0'
            menu.classList.remove('active')
            menu.setAttribute('aria-hidden', 'true')
            menu.style.zIndex = '0'
            menu.style.visibility = 'hidden'
            Array.from(menu.children).forEach((li) => {
                li.style.display = 'none'
            })
        }

        const showMenu = (menu, item) => {
            if (window.innerWidth > 640) {
                menu.style.padding = '0.5rem'
                menu.style.paddingTop = '6rem'
            }
            else {
                menu.style.paddingTop = '2rem'
                menu.style.marginBottom = '-0.5rem'
                const anchor = item.querySelector('a')
                if (anchor)
                    anchor.style.marginBottom = '1rem'
            }

            menu.style.visibility = 'visible'
            menu.classList.add('active')
            menu.setAttribute('aria-hidden', 'false')
            menu.style.zIndex = '-1'
            item.style.zIndex = '10'
            Array.from(menu.children).forEach((li) => {
                li.style.display = ''
            })
        }

        Array.from(navTertiaryAll).forEach((item) => {
            const menu = item.querySelector('.nav-tertiary__nav')
            const arrow = item.querySelector('.nav-tertiary__arrow')
            if (!menu || !arrow)
                return

            menu.setAttribute('aria-hidden', 'true')
            menu.style.visibility = 'hidden'
            menu.style.padding = '0'
            Array.from(menu.children).forEach((li) => {
                li.style.display = 'none'
            })

            const toggleTertNav = () => {
                if (menu.classList.contains('active')) {
                    hideMenu(menu)
                    arrow.setAttribute('aria-expanded', 'false')
                    arrow.classList.remove('active')
                    item.style.zIndex = '0'

                    if (window.innerWidth <= 640) {
                        Array.from(navTertiaryAll).forEach((navItem) => {
                            const anchor = navItem.querySelector('a')
                            if (anchor)
                                anchor.style.marginBottom = '0'
                            navItem.style.marginBottom = '0.5rem'
                        })
                    }
                    else {
                        Array.from(navTertiaryAll).forEach((navItem) => {
                            navItem.style.marginBottom = '0rem'
                        })
                    }

                    Array.from(navTertMenuAll).forEach((navMenu) => {
                        navMenu.style.marginBottom = '0'
                    })
                }
                else {
                    Array.from(navTertMenuAll).forEach((navMenu) => {
                        hideMenu(navMenu)
                    })
                    Array.from(document.getElementsByClassName('nav-tertiary__arrow')).forEach((navArrow) => {
                        navArrow.setAttribute('aria-expanded', 'false')
                        navArrow.classList.remove('active')
                    })
                    Array.from(navTertiaryAll).forEach((navItem) => {
                        navItem.style.zIndex = '0'
                    })
                    Array.from(navTertMenuAll).forEach((navMenu) => {
                        navMenu.style.paddingTop = '0'
                    })

                    showMenu(menu, item)
                    arrow.setAttribute('aria-expanded', 'true')
                    arrow.classList.add('active')
                }
            }

            arrow.addEventListener('click', toggleTertNav)
            arrow.addEventListener('keypress', (e) => {
                if (e.charCode === 13)
                    toggleTertNav()
            })
            arrow.addEventListener('touchend', (event) => {
                event.preventDefault()
                toggleTertNav()
            })
        })
    }
}

const navBar = document.getElementsByClassName('nav')[0]
const navMain = document.getElementsByClassName('nav-content__wrapper')[0]
const mainContent = document.getElementsByClassName('main-content')
const open = document.getElementsByClassName('nav__menu')
const searchIcon = document.getElementsByClassName('nav__icon-search')
const searchPage = document.getElementsByClassName('nav__search-wrapper')
const searchInputPage = document.getElementsByClassName('results__input')

if (open.length > 0) {
    open[0].addEventListener('click', () => {
        if (navMain.classList.contains('active')) {
            navBar.classList.remove('open');
            navMain.classList.remove('active')
            open[0].classList.remove('active')
            open[0].setAttribute('aria-expanded', 'false')
            mainContent[0].setAttribute('aria-hidden', 'false')
            document.body.classList.remove('menu--open');
            // if (window.innerWidth <= 640) {
            open[0].getElementsByClassName('nav__menu-text')[0].innerHTML = '&nbsp;&nbsp;Menu'
            // }
            // if (window.innerWidth < 640) {
            //     navBar.classList.remove('active')
            // }
            if(searchIcon[0].classList.contains('active')) {
                searchIcon[0].classList.remove('active')
                searchPage[0].classList.remove('active')
            }
        }
        else {
            navMain.classList.add('active')
            navBar.classList.add('open');
            open[0].classList.add('active')
            open[0].setAttribute('aria-expanded', 'true')
            mainContent[0].setAttribute('aria-hidden', 'true')
            open[0].getElementsByClassName('nav__menu-text')[0].innerHTML = '&nbsp;&nbsp;Close'
            document.body.classList.remove('search--open');
            document.body.classList.add('menu--open');
            if (window.innerWidth > 640) {
                navMain.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            }
            else {
                navMain.scrollTo(0, -1000)
            }
            // if (window.innerWidth < 640) {
            //     navBar.classList.add('active')
            // }
            if(searchIcon[0].classList.contains('active')) {
                searchIcon[0].classList.remove('active')
                searchPage[0].classList.remove('active')
            }
        }
    })

    open[0].addEventListener('keypress', (e) => {
        if (e.charCode === 13) {
            if (navMain.classList.contains('active')) {
                navMain.classList.remove('active')
                open[0].classList.remove('active')
                open[0].setAttribute('aria-expanded', 'false')
                mainContent[0].setAttribute('aria-hidden', 'false')
                document.body.classList.remove('menu--open');
                // if (window.innerWidth <= 640) {
                    open[0].getElementsByClassName('nav__menu-text')[0].innerHTML = '&nbsp;&nbsp;Menu'
                // }
                // if (window.innerWidth < 640) {
                //     navBar.classList.add('active')
                // }
            }
            else {
                navMain.classList.add('active')
                open[0].classList.add('active')
                open[0].setAttribute('aria-expanded', 'true')
                mainContent[0].setAttribute('aria-hidden', 'true')
                open[0].getElementsByClassName('nav__menu-text')[0].innerHTML = '&nbsp;&nbsp;Close'
                document.body.classList.add('menu--open');
                if (window.innerWidth > 640) {
                    navMain.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                }
                else {
                    navMain.scrollTo(0, -1000)
                }
                // if (window.innerWidth < 640) {
                //     navBar.classList.add('active')
                // }
            }
        }
    })
}

if (searchIcon.length > 0) {
    searchIcon[0].addEventListener('click', () => {
        if (searchPage[0].classList.contains('active')) {
            searchPage[0].classList.remove('active')
            searchIcon[0].classList.remove('active')
            // navLogo[0].classList.remove('active')
            // navRight[0].classList.remove('active')
            searchIcon[0].setAttribute('aria-expanded', 'false')
            document.body.classList.remove('search--open');
        }
        else {
            searchPage[0].classList.add('active')
            searchIcon[0].classList.add('active')
            // navRight[0].classList.add('active')
            // navLogo[0].classList.add('active')
            searchIcon[0].setAttribute('aria-expanded', 'true')
            document.body.classList.add('search--open');
            document.body.classList.remove('menu--open');
            searchInputPage[0].focus()


            if (navMain.classList.contains('active')) {
                navMain.classList.remove('active')
                open[0].classList.remove('active')
                open[0].setAttribute('aria-expanded', 'false')
                mainContent[0].setAttribute('aria-hidden', 'false')
                // if (window.innerWidth <= 640) {
                    open[0].getElementsByClassName('nav__menu-text')[0].innerHTML = '&nbsp;&nbsp;Menu'
                // }
                if (window.innerWidth < 640) {
                    navBar.classList.remove('active')
                }
            }
        }
    })

    searchIcon[0].addEventListener('keypress', (e) => {
        if (e.charCode === 13) {
            if (searchPage[0].classList.contains('active')) {
                searchPage[0].classList.remove('active')
                searchIcon[0].classList.remove('active')
                // navLogo[0].classList.remove('active')
                // navRight[0].classList.remove('active')
                searchIcon[0].setAttribute('aria-expanded', 'false')
                document.body.classList.remove('search--open');
            }
            else {
                searchPage[0].classList.add('active')
                searchIcon[0].classList.add('active')
                // navRight[0].classList.add('active')
                // navLogo[0].classList.add('active')
                searchIcon[0].setAttribute('aria-expanded', 'true')
                document.body.classList.add('search--open');
                searchInputPage[0].focus()

                if (navMain.classList.contains('active')) {
                    navMain.classList.remove('active')
                    open[0].classList.remove('active')
                    open[0].setAttribute('aria-expanded', 'false')
                    mainContent[0].setAttribute('aria-hidden', 'false')
                    // if (window.innerWidth <= 640) {
                    open[0].getElementsByClassName('nav__menu-text')[0].innerHTML = '&nbsp;&nbsp;Menu'
                    // }
                    if (window.innerWidth < 640) {
                        navBar.classList.remove('active')
                    }
                }
            }
        }
    })
}
